/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';

import { END } from 'redux-saga';
import dynamic from 'next/dynamic';
import { GetServerSideProps } from 'next';
import { useSelector } from 'react-redux';

import { objectIsEmpty } from 'utils/objectEmpty';
import { IState, SagaStore, storeWrapper } from 'store';
import { loadProductData, IProductProps } from 'store/modules/product';
import { GAEvent, getGAViewItemsFromProductPDP, getPageView } from 'utils/gtag';

import Layout from 'components/Layout';
import SEO from 'components/common/SEO';
import { Product } from 'components/common/Templates/Product';
import { Description } from 'components/pages/PDP/Description';
import NavigationPages from 'components/common/NavigationPages';
import { ProductWarnings } from 'components/pages/PDP/ProductWarnings';
import { ProductRatingReviews } from 'components/pages/PDP/ProductRatingReviews';
// import ProductCarousel from 'components/common/Templates/Carousel/ProductCarousel';

const Error404 = dynamic(() => import('components/common/Error404'));

import * as S from 'styles/pages/App/PDP';

export default function PDP() {
  const product = useSelector<IState, IProductProps>(
    state => state.product.product,
  );

  useEffect(() => {
    GAEvent({ action: 'page_view', data: getPageView() });
  }, []);

  useEffect(() => {
    if (product.correlatados && product.correlatados.length)
      GAEvent({
        action: 'view_item_list',
        data: getGAViewItemsFromProductPDP({
          products: product.correlatados,
          itemListId: 'CONFIRA OUTRAS OPÇÕES',
          itemListName: 'CONFIRA OUTRAS OPÇÕES',
        }),
      });
  }, [product]);

  if (objectIsEmpty(product)) {
    return (
      <Layout>
        <SEO />
        <Error404 />
      </Layout>
    );
  }

  return (
    <Layout>
      <SEO
        title={product.seo.seo_Titulo}
        description={product.seo.seo_Descricao}
        keywords={product.seo.seo_PalavrasChaves}
      />

      <S.Container className="pdp">
        <div id="product-detail" className="pdp-details">
          {product.navegacaoPorLoja && (
            <NavigationPages navigationPages={product.navegacaoPorLoja} />
          )}

          <Product product={product} />

          {product.farmacia.medicamento && (
            <ProductWarnings
              productName={product.nome}
              farmacia={product.farmacia}
            />
          )}

          <Description product={product} />
        </div>

        {/* <div className="previously-viewed">
          <h3>Vistos anteriormente:</h3>
          <ProductCarousel items={products} />
        </div> */}

        <ProductRatingReviews
          product={product}
          rating={product.resumoAvaliacao}
        />
      </S.Container>
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps =
  storeWrapper.getServerSideProps(async ({ params, store, res, query }) => {
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=600, stale-while-revalidate=600',
    );

    const { slug } = params;

    store.dispatch(loadProductData({ sku: slug }));

    store.dispatch(END);

    await (store as SagaStore).sagaTask.toPromise();

    const state = store.getState();
    const product = state.product.product;

    if (!product || !product.ativo) {
      return {
        redirect: {
          destination: '/',
          permanent: false,
        },
      };
    }

    return {
      props: {},
    };
  });
